import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from 'environment';
import { Rest } from './rest';

const BACKEND_URL = environment.backendUrl + '/';

@Injectable()
export class SyncRest extends Rest {
  constructor(
    public http: HttpClient
  ) {
    super(http);
  }

  csvReport(request: any): any {
    let ref = BACKEND_URL + 'sync/csv?token=' + localStorage.token;
    if (request.startDate) { ref += '&startDate=' + new Date(request.startDate).toISOString(); }
    if (request.endDate) { ref += '&endDate=' + new Date(request.endDate).toISOString(); }
    window.location.href = ref;
  }
}
